import TagManager from 'react-gtm-module';

import { isDevelopment } from 'utils/constants/constants';

const dataLayerName = 'PageDataLayer';

const sendGTM = (dataLayer: any) => {
  if (!isDevelopment) {
    TagManager.dataLayer({ dataLayer, dataLayerName });
  }
};

export default sendGTM;
